import { useSelector } from "react-redux";
import { ClipLoader } from "react-spinners";
import { AppState } from "../../../redux/types";


export default function ComponentLoader() {
  const siteConfigRootColors = useSelector((state: AppState) => state.siteThemeConfig.colors)

  return(
    <div className="flex-center">
      <ClipLoader color={siteConfigRootColors.primary_default}/>
    </div>
  )  
}